
// Legacy function - kept for backward compatibility
const sendAncillaryAddToCartEvent = (ancillaryData) => {
  if (!window.cioanalytics?.track) {
    return false;
  }
  window.cioanalytics.track('ancillary_addtocart', ancillaryData);
  return true;
};

// Main integration function
const sendAncillaryEventToCustomerIO = (ancillaryType, eventData, pnrData, additionalProperties = {}) => {
  try {
    const pnrInfo = extractEssentialPNRData(pnrData);

    if (!pnrInfo.pnrCode) {
      return;
    }
    
    if ((!pnrInfo?.email || pnrInfo?.email?.trim() === '') && (!pnrInfo?.phone || pnrInfo?.phone?.trim() === '')) {
      return ;
    }

    const customerIOEventName = determineEventName(eventData?.event);
    const ancillaryEvent = {
      ancillaryType,
      PNR: pnrInfo.pnrCode,
      email: pnrInfo.email,
      phone: pnrInfo.phone || '',
      passengerName: pnrInfo.firstName || '',
      passengerLastName: pnrInfo.lastName || '',
      destination: pnrInfo.destination || '',
      timestamp: Math.floor(Date.now() / 1000),
      ...additionalProperties,
    };

    return sendToCustomerIO(customerIOEventName, ancillaryEvent);
  } catch (error) {
    // Silent error
  }
};


const extractEssentialPNRData = (pnrData) => {
  const primaryTraveler = pnrData?.cart?.travelerCollection?.[0] || {};
  const legCollection = pnrData?.legCollection || [];
  const outboundSegments = legCollection[0]?.segmentsCollection || [];
  const destination = outboundSegments[outboundSegments.length - 1]?.arrivalAirport;
  let phone = '';

  if (Array.isArray(primaryTraveler?.phones?._collection) && primaryTraveler?.phones?._collection?.length > 0) {
    phone = `${primaryTraveler.phones._collection[0].country}${primaryTraveler.phones._collection[0].number}`;
  }

  return {
    pnrCode: pnrData?.pnrCode,
    email: primaryTraveler.email,
    phone, 
    firstName: primaryTraveler.firstName,
    lastName: primaryTraveler.lastName,
    destination: destination,
  };
};


const determineEventName = (gtmEventType) => {
  const eventMap = {
    'view_item_list': 'ancillary_view',
    'view_item': 'ancillary_view',
    'add_to_cart': 'ancillary_addtocart',
    'select_item': 'ancillary_addtocart',
    'purchase': 'ancillary_purchase',
    'am_error': 'ancillary_error',
    'productImpression': 'ancillary_view',
  };
  
  return eventMap[gtmEventType] || 'ancillary_view';
};

/**
 * @param {string} eventName - Customer.io event name
 * @param {Object} eventData - Event data
 * @returns {boolean} - Success status
 */
const sendToCustomerIO = (eventName, eventData) => {
  if (!window.cioanalytics?.track) {
    // Silent error
    return false;
  }

  window.cioanalytics.track(eventName, eventData);
  return true;
};

export {
  sendAncillaryAddToCartEvent,
  sendAncillaryEventToCustomerIO,
  extractEssentialPNRData,
  determineEventName,
  sendToCustomerIO,
};

export default {
  sendAncillaryAddToCartEvent,
  sendAncillaryEventToCustomerIO,
  extractEssentialPNRData,
  determineEventName,
  sendToCustomerIO,
};
